/**
 * Mirrors Server/Courtney.Care/Models/ContactFormModel.cs. The API serializes enums as strings
 * and properties as camelCase (see WebApiConfig.cs), so these names match the wire format.
 */
export type OkayTo = 'Text' | 'Call' | 'Both';

export type Category = 'Nannying' | 'Babysitting';

export type ContactFormRequest = {
  name: string;
  email: string;
  phoneNumber?: string;
  okayTo?: OkayTo;
  category: Category | '';
  message: string;
  numberOfChildren?: number;
  agesOfChildren?: string;
  captchaToken: string;
};

/** Every field the form can flag, plus a slot for errors that belong to no single field. */
export type FieldErrors = Partial<Record<keyof ContactFormRequest | 'form', string>>;

export const okayToOptions: { value: OkayTo; label: string }[] = [
  { value: 'Text', label: 'Text me' },
  { value: 'Call', label: 'Call me' },
  { value: 'Both', label: 'Call or text me' },
];

export const categoryOptions: { value: Category; label: string }[] = [
  { value: 'Nannying', label: 'Nannying' },
  { value: 'Babysitting', label: 'Babysitting' },
];
